var Reflux  = require('reflux'),
    request = require('superagent');

var ChannelsActions = require('advocate/challenges/actions/channels_actions');

var ChannelsCollection = Reflux.createStore({
  listenables: ChannelsActions,

  init: function(){
    this.data = {
      channels : [],
      errors : null,
      hideCounters: false
    };
  },

  mapChannelCounters :  function(){
    const { channels, channel_counters } = this.data

    this.data.channels = _.map(channels, function(channel) {
      return _.extend(channel, _.find(channel_counters, { channel_id: channel.id }))
    });
  },

  fetchChannelCounters : function(){
    request.get('/challenges/channel_counters')
      .set('Accept', 'application/json')
      .set('X-Requested-With', 'XMLHttpRequest')
      .end((errors, response) => {
          if(response.ok){
            this.data.channel_counters = response.body.data;
            this.data.errors = null;
            this.mapChannelCounters();
          } else {
            this.data.channel_counters = [];
            this.data.errors = errors;
          }
          this.trigger(this.data);
        }
      );
  },

  onFetchChannels : function(){
    request.get('/channels')
      .set('Accept', 'application/json')
      .set('X-Requested-With', 'XMLHttpRequest')
      .end((errors, response) => {
          if(response.ok){
            this.data.channels = response.body;
            this.data.errors = null;
            this.fetchChannelCounters();
          } else {
            this.data.channels = [];
            this.data.errors = errors;
          }
        }
      );
  },

  onShowChannel: function(channelId) {
    window.location = `/channels/${channelId}`;
  }
});

module.exports = ChannelsCollection;



// WEBPACK FOOTER //
// ./src/advocate/challenges/stores/channels_collection.js